import {Buttons} from "./components/Buttons"
import { Typo } from "./components/Typography";

import './App.css';

function App() {
  return (
    <div className="App">
      <Typo/>
      <Buttons/>
    </div>
  );
}

export default App;
